import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import React, {useState} from 'react';
import Select from 'react-select';
import natDex from './api/dexCompleta';
import html2canvas from 'html2canvas';
import AdsComponent from './componentes/AdsComponent';
import Footer from './componentes/Footer';

function App() {

  const [pokeList, setPokemon] = useState({});
  const [language, setLanguage] = useState("es");
 // const [pokeSelection, setPokemonSelection] = useState([]);

  const addPokemon = (e, type) =>{
    const selectType = type.toLowerCase();
    const selectedValue = e.value;
  
    setPokemon({ ...pokeList, [selectType]: selectedValue });
  //  setPokemonSelection(selectedValue);
    
  }

  const MySwal = withReactContent(Swal)

  //console.log(pokeList)

  const handleLang = (e) => {
    const selectedLang = e.target.value;
    setLanguage(selectedLang);
  }
  //console.log(language)

  // const rutaImgs = "./favoritetypes";
  // const rutaImgsPokes = "./favoritetypes/img/artworks/";
  const rutaImgs = "";
  const rutaImgsPokes = "./img/artworks/";


  // Función para traducir los textos de la app
  const textLang = (language, text) =>{
    const textLang = 
    {
      h1: {es: "Generador de tus Pokémon favoritos de cada tipo", en: "Favorite Pokémon of each type image generator", fr: "Votre Pokémon préféré de chaque type", de: "Dein Lieblingspokémon jeder Art", it: "Il tuo Pokémon preferito di ogni tipo", jp: "あなたのお気に入りのポケモン"},

      h2: {es: "Selecciona un Pokémon de cada tipo", en: "Select a Pokémon of each type", fr: "Sélectionnez un Pokémon de chaque type", de: "Wählen Sie ein Pokémon von jedem Typ aus", it: "Seleziona un Pokémon di ogni tipo.", jp: "それぞれのタイプのポケモンを選んでください。"},

      parrafo: {es: `<p>¡Diviértete utilizando nuestra herramienta para generar una imagen de tus Pokémon favoritos de cada tipo!</p>
      <p>Para generar una imagen con tus tipos favoritos primero debes seleccionar un Pokémon de cada tipo, luego presiona el botón Generar & Descargar y listo!</p>`, en: `<p>Have fun using our tool to generate an image of your favorite Pokémon of each type!</p><p>To generate an image with your favorite types, you must first select one Pokémon of each type, then press the Generate & Download button, and you're all set!</p>`, fr: `<p>Amusez-vous en utilisant notre outil pour générer une image de vos Pokémon préférés de chaque type !</p><p>Pour générer une image avec vos types favoris, vous devez d'abord sélectionner un Pokémon de chaque type, puis appuyez sur le bouton Générer & Télécharger et c'est tout !</p>`, de: `<p>Viel Spaß beim Verwenden unseres Tools zur Generierung eines Bildes deiner Lieblings-Pokémon jedes Typs!</p><p>Um ein Bild mit deinen Lieblingstypen zu generieren, musst du zuerst ein Pokémon von jedem Typ auswählen, dann drücke den Button Generieren & Herunterladen und fertig!</p>`, it: `<p>Divertiti utilizzando il nostro strumento per generare un'immagine dei tuoi Pokémon preferiti di ogni tipo!</p><p>Per generare un'immagine con i tuoi tipi preferiti, devi prima selezionare un Pokémon di ogni tipo, quindi premere il pulsante Genera & Scarica e sei pronto!</p>`, jp: `<p>各タイプのお気に入りのポケモンの画像を生成するためのツールを使って楽しんでください！</p><p>お気に入りのタイプで画像を生成するには、まず各タイプのポケモンを選択し、その後に生成＆ダウンロードボタンを押してください。それで完成です！</p>`},
      
      selectLabel: {es: "Selecciona un Pokémon", en: "Select a Pokémon", fr: "Sélectionne un Pokémon", de: "Wähle ein Pokémon aus", it: "Seleziona un Pokémon", jp: "ポケモンを選んでください"},

      languagePath: {es: "es", en: "en", fr: "fr", de: "de", it: "it", jp: "jp"},

      createYourOwn: {es: "Genera el tuyo en centropkmn.com", en: "Create your own at centropkmn.com", fr: "Générez le vôtre sur centropkmn.com", de: "Generieren Sie Ihre eigene auf centropkmn.com", it: "Genera il tuo su centropkmn.com", jp: "であなた自身のものを生成してください。centropkmn.com"},

      typeLanguage: {es: "Tipo", en: "Type", fr: "Type", de: "Typ", it: "Tipo", jp: "タイプ"},

      downloadBtn: {es: "Generar y descargar", en: "Generate & Download", fr: "Generate & Download", de: "Generate & Download", it: "Generate & Download", jp: "Generate & Download"},

      alert: {es: "Debes seleccionar un Pokémon de cada tipo antes de generar la imagen.", en: "You must select a Pokémon of each type before generating the image.", fr: "Vous devez sélectionner un Pokémon de chaque type avant de générer l'image.", de: "Du musst ein Pokémon von jedem Typ auswählen, bevor das Bild generiert wird.", it: "Dovresti selezionare un Pokémon di ogni tipo prima di generare l'immagine.", jp: "画像を生成する前に、各タイプのポケモンを選択する必要があります。"},

      preview: {es: "Vista Previa", en: "Preview", fr: "Aperçu", de: "Vorschau", it: "Anteprima", jp: "プレビュー"},

      previewText: {es: "A continuación puedes visualizar como está quedando tu imagen en tiempo real. Sin embargo para poder descargarla deberás presionar en el botón de Generar & Descargar que se encuentra más abajo.", en: "Below, you can see a real-time preview of how your image is looking. However, to download it, you need to press the Generate & Download button located further below.", fr: "Ci-dessous, vous pouvez voir un aperçu en temps réel de l'apparence de votre image. Cependant, pour la télécharger, vous devez appuyer sur le bouton Générer et Télécharger situé plus bas.", de: "Unten sehen Sie eine Echtzeitvorschau, wie Ihr Bild aussieht. Um es jedoch herunterzuladen, müssen Sie auf die Schaltfläche Generieren und Herunterladen unten drücken.", it: "Di seguito puoi visualizzare un'anteprima in tempo reale di come sta venendo la tua immagine. Tuttavia, per poterla scaricare, devi premere il pulsante Genera e Scarica che si trova più in basso.", jp: "以下では、イメージがリアルタイムでどのように表示されているかをプレビューできます。ただし、ダウンロードするには、下部にある「生成してダウンロード」ボタンを押す必要があります。"},
    }

    switch (language) {
      case "es":
        return textLang[text].es;
        
      case "en":
        return textLang[text].en;
        
      case "jp":
        return textLang[text].jp;
        
      case "fr":
        return textLang[text].fr;
        
      case "de":
        return textLang[text].de;
        
      case "it":
        return textLang[text].it;
        
      default:
        return "Error"
        
    }
  }

  const instructions = {__html: textLang(language, "parrafo")}

  // Array solo con los tipos en ingles
  const allTypes = [
    "Grass", "Fire", "Water", "Normal", "Electric", "Psychic", "Fighting", "Rock", "Ground", "Flying", "Bug", "Poison", "Dark", "Ghost", "Ice", "Steel", "Dragon", "Fairy"
  ];

  //Array con objetos para todos los idiomas de los tipos
  const allTypesObj = 
    {
      typeEn: ["Grass", "Fire", "Water", "Normal", "Electric", "Psychic", "Fighting", "Rock", "Ground", "Flying", "Bug", "Poison", "Dark", "Ghost", "Ice", "Steel", "Dragon", "Fairy"],

      typeEs: ["Planta", "Fuego", "Agua", "Normal", "Eléctrico", "Psíquico", "Lucha", "Roca", "Tierra", "Volador", "Bicho", "Veneno", "Siniestro", "Fantasma", "Hielo", "Acero", "Dragón", "Hada"],

      typeIt: ["Erba", "Fuoco", "Acqua", "Normale", "Elettro", "Psico", "Lotta", "Roccia", "Terra", "Volante", "Coleott", "Veleno", "Buio", "Spettro", "Ghiaccio", "Acciaio", "Drago", "Folletto"],

      typeFr: ["Plante", "Feu", "Eau", "Normal", "Électrik", "Psy", "Combat", "Roche", "Sol", "Vol", "Insecte", "Poison", "Ténèbres", "Spectre", "Glace", "Acier", "Dragon", "Fée"],

      typeDe: ["Pflanze", "Feuer", "Wasser", "Normal", "Elektro", "Psycho", "Kampf", "Gestein", "Boden", "Flug", "Käfer", "Gift", "Unlicht", "Geist", "Eis", "Stahl", "Drache", "Fee"],

      typeJp: ["くさ", "ほのお", "みず", "	ノーマル", "でんき", "エスパー", "かくとう", "いわ", "じめん", "ひこう", "むし", "どく", "あく", "ゴースト", "こおり", "はがね", "ドラゴン", "フェアリー"],
    };

  
  //Funcion que retorna un array que filtra todos los Pokémon del mismo tipo pasado por argumento (type)
  const typesFilter = (type)=>{
    const typeFilter = natDex.filter((pokemon)=> pokemon.type1 === type || pokemon.type2 === type)
    return typeFilter;
  }


  //Estructura de los Select de cada tipo
  const typesArray = allTypes.map((type) => {

    return (
    <div key={type} id={`${type.toLowerCase()}-type`} className={`imgType${type.charAt(0).toUpperCase() + type.slice(1)} col-lg-3 col-md-5 m-1 p-3 rounded-3`}>
     
      <label className='text-white fw-bold text-shadow'>{
      language === "en" || language === "jp" ?
      
      (`${
        (() => {
          switch (language) {
            case "en":
              return allTypesObj.typeEn[allTypes.indexOf(type)];
            case "jp":
              return allTypesObj.typeJp[allTypes.indexOf(type)];
            default:
              break;
          }
        })()
      } ${textLang(language, "typeLanguage")}`)
      
      : 

      (`${textLang(language, "typeLanguage")} 
      ${
        (() => {
          switch (language) {
            case "es":
              return allTypesObj.typeEs[allTypes.indexOf(type)];
            case "it":
              return allTypesObj.typeIt[allTypes.indexOf(type)];
            case "fr":
              return allTypesObj.typeFr[allTypes.indexOf(type)];
            case "de":
              return allTypesObj.typeDe[allTypes.indexOf(type)];
            default:
              break;
          }
        })()
      }`)
      
      }</label>
      <br/>

      <Select
          
          name={`${type.toLowerCase()}`}
          placeholder= {textLang(language, "selectLabel")}
          onChange={(e) => addPokemon(e, type)}
          value={pokeList[type.toLowerCase()]}
          noOptionsMessage={() => "Nope :("}
          options={typesFilter(type).map((pokemon, index) => ({
            value: pokemon.img,
            label: `${pokemon.dex} ${language === "jp" ? pokemon.name_jp : pokemon.name}`
            
            }))
          }
      />

      <div className='text-center'>
        <img src={rutaImgsPokes + pokeList[type.toLowerCase()]} width="150px" className='mt-3' alt=""/>
      </div>
    </div>

  )});

  // FUNCION verificarSeleccion: con Object.keys(obj).length podemos obtener la cantidad de claves que hay en un objeto (lo usamos para verificar si se completo la seleccion de pokemon antes de descargar la imagen). La funcion devuelve true o false segun corresponda
  const verificarSeleccion = () =>{
    return (Object.keys(pokeList).length === 18)
  }

  // Funcion para mostrar la imagen generada en pantalla y luego descargar automaticamente invocando a la funcion descarga()
  const toggleOcultar = () => {
    if(!verificarSeleccion()) {
      // Alert que aparece si la verificacion da false
      MySwal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `${textLang(language,"alert")}`
      })
      return;
    } else {
      // const exportar = document.getElementById('exportar');
      // if(exportar.classList.contains('ocultar')){
      //   exportar.classList.remove('ocultar');
      //   descarga();
      // } else {
      //   descarga();
      // }
      descarga();
    }
  }

  //Funcion de descarga con html2canvas
  const descarga = (ev) => {
    html2canvas(document.getElementById('exportar'),{useCORS:true}).then(function(canvas) {
      
      let img = canvas.toDataURL("image/jpeg", 1.0);
      //console.log(img)
      let link = document.createElement("a");
      link.download = "favoriteTypes.jpg";
      link.href = img;
      link.click();
    }); 
  }
  

  return (
    <>
    <header className='sticky-top'>

    <nav className="navbar navbar-expand-md">
      <div className="container-fluid">
        <a className="navbar-brand" href="https://www.centropkmn.com">
        <img src="./img/cplogo-hdpi.png" alt="Centro Pokémon" width="100px" height="100%"/>
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link  text-white" aria-current="page" href="https://www.centropkmn.com">Noticias</a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-white" href="https://www.centropkmn.com/juegos/?por_generacion=1">Listado de juegos</a>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle text-white" href="https://www.centropkmn.com/seccion/trucos/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Trucos de Pokémon
              </a>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="https://www.centropkmn.com/seccion/trucos/trucos-pokemon-rubi-zafiro/">Trucos Pokémon Rubí/Zafiro</a></li>
                <li><a className="dropdown-item" href="https://www.centropkmn.com/seccion/trucos/trucos-pokemon-esmeralda/">Trucos Pokémon Esmeralda</a></li>
                <li><a className="dropdown-item" href="https://www.centropkmn.com/seccion/trucos/trucos-pokemon-rojofuego-verdehoja/">Trucos Pokémon Rojo Fuego/Verde Hoja</a></li>
                <li><a className="dropdown-item" href="https://www.centropkmn.com/seccion/trucos/trucos-pokemon-diamante-y-perla/">Trucos Pokémon Diamante/Perla</a></li>
                <li><a className="dropdown-item" href="https://www.centropkmn.com/seccion/trucos/trucos-pokemon-heart-gold-y-soul-silver/">Trucos Pokémon HeartGold/SoulSilver</a></li>
                <li><a className="dropdown-item" href="https://www.centropkmn.com/seccion/trucos/trucos-pokemon-black-white/">Trucos Pokémon Negro/Blanco</a></li>
                <li><a className="dropdown-item" href="https://www.centropkmn.com/go/trucos/los-mejores-trucos-y-consejos-de-pokemon-go/">Trucos Pokémon GO</a></li>
              </ul>
            </li>
          </ul>
          
        </div>
      </div>
    </nav>
    </header>
    

    <div className='container bg-white mt-3 pt-4 rounded-4'>
        
        <div id='languages' className='w-100 d-flex justify-content-end'>
            <label htmlFor="languages" className='me-1 fw-bolder'><img src="./img/languages.png" alt="Translate" width={35} /> Translate</label>
            <select onChange={handleLang}>
            <option value="es">Español</option>
            <option value="en">English</option>
            <option value="jp">日本語</option>
            <option value="de">Deutsch</option>
            <option value="it">Italiano</option>
            <option value="fr">Français</option>
            </select>
        </div>
        
        <h1 className='text-md-center p-2 fw-bolder h1Gradient'>{textLang(language, "h1")}</h1>

        <div className='d-flex justify-content-center mb-3'>  
        <AdsComponent dataAdSlot='6537497653' clase='adsHeader' />
        </div>

        <div id='instructions' className='bg-dark text-white px-3 pt-3 pb-1 rounded-3 mb-2' dangerouslySetInnerHTML={instructions}/>
      
      <main>

        <h2 className='p-2'>{textLang(language,"h2")}</h2>
        

        <div className='d-md-flex flex-md-wrap justify-content-center'>
          {
          
          typesArray
          
          }
        </div>
          
        <div className='bg-success text-white my-3 p-3 rounded-3 '>
          <h2>{textLang(language, "preview")}</h2>
          <p>{textLang(language, "previewText")}</p>
        </div>
       
      {/* IMAGEN GENERADA */}
      <div id='exportar' className='mt-3 imagenBg'>
        
          <div className='row g-0 text-center'>
            <div  className='col'>  
              <img src={`${rutaImgs}img/bg-types/title/${textLang(language,"languagePath")}/titulo.webp`} className='img-fluid p-3' alt=""/>
            </div>
          </div>
    
          <div className='row g-0  text-center'>
            
            <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeGrass'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/planta.png`} className='img-fluid' alt=""/>
                </div>
              <img src={rutaImgsPokes + pokeList.grass} className='imgPoke' alt=""/>
            </div>
            <div className='col-md-2 col-4 contenedorImg'>
              <div className='types imgTypeFire'>
                <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/fuego.png`} className='img-fluid' alt=""/>
              </div>
              <img src={rutaImgsPokes + pokeList.fire} className='imgPoke' alt=""/>
            </div>
            <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeWater'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/agua.png`} className='img-fluid' alt=""/>
                </div>              
              <img src={rutaImgsPokes + pokeList.water} className='imgPoke' alt=""/>
            </div>
            <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeNormal'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/normal.png`} className='img-fluid' alt=""/>
                </div>  
              <img src={rutaImgsPokes + pokeList.normal} className='imgPoke' alt=""/>
            </div>
            <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeElectric'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/electrico.png`} className='img-fluid' alt=""/>
                </div> 
              <img src={rutaImgsPokes + pokeList.electric} className='imgPoke' alt=""/>
            </div>
            <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypePsychic'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/psiquico.png`} className='img-fluid' alt=""/>
                </div> 
              <img src={rutaImgsPokes + pokeList.psychic} className='imgPoke' alt=""/>
            </div>
          </div>
          <div className='row g-0 text-center'>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeFighting'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/lucha.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.fighting} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeRock'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/roca.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.rock} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeGround'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/tierra.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.ground} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeFlying'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/volador.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.flying} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeBug'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/bicho.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.bug} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypePoison'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/veneno.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.poison} className='imgPoke' alt=""/>
              </div>
          </div>
          <div className='row g-0 text-center'>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeDark'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/siniestro.png`} className='img-fluid' alt=""/>
                  
                </div> 
                <img src={rutaImgsPokes + pokeList.dark} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeGhost'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/fantasma.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.ghost} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeIce'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/hielo.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.ice} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeSteel'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/acero.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.steel} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeDragon'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/dragon.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.dragon} className='imgPoke' alt=""/>
              </div>
              <div className='col-md-2 col-4 contenedorImg'>
                <div className='types imgTypeFairy'>
                  <img src={`${rutaImgs}img/bg-types/types/${textLang(language,"languagePath")}/hada.png`} className='img-fluid' alt=""/>
                </div> 
                <img src={rutaImgsPokes + pokeList.fairy} className='imgPoke' alt=""/>
              </div>
          </div>
          <div className='row g-0 text-center'>
            <div  className='col'>
              
              <p className='text-shadow text-footer bg-footer'>{textLang(language, "createYourOwn")}</p>
            
            </div>
          </div>
       </div>
      <div className='d-flex justify-content-center mt-3'>  
          <AdsComponent dataAdSlot='6968742499' clase='adsMedio' />
      </div>
       <div className='text-center'>
       <button className='btn btn-outline-success m-3 w-75 fw-bolder text-uppercase' type="button" onClick={toggleOcultar}>{`${textLang(language,"downloadBtn")}`}</button>
       </div>
      </main>

    </div>
    <Footer />
    </>
  );
}

export default App;
